import "./IconExportPdf.scss";

export const IconExportPdf = ({ outline = false, className = "" }: { outline?: boolean; className?: string }) => {
  return <span className={`icon-export-pdf${outline ? "-outline" : ""} ${className}`}></span>;
};
